<form novalidate (ngSubmit)="goNext()" [formGroup]="previousResidenceInfoForm" [ngClass]='{"h-100": !this.isBuyNow && !isLegacyCreditApp}'>
  <div class="row m-0 previous-residence-info credit-app-body"  [ngClass]='{"noshadow": this.isBuyNow || isLegacyCreditApp, "pl-4 pr-4": !this.isBuyNow && !isLegacyCreditApp}'>
    <div class="col-12 col-lg-11 {{isBuyNow || isLegacyCreditApp ? 'col-xl-11-half' : ''}} scrollDiv nopad">
      <div class="row m-0">
        <!-- *************************** PreviousAddress1 START ***************************  -->
        <div class="col-12 col-lg-6 col-xl-4 px-0 pr-lg-3 sbc" id='searchBoxContainer'>
          <label>{{ prevResidenceInfoConfigData?.AddressLine1label }}</label>
          <input class="form-control w-100 pr-5" id="previous_address1" formControlName="PreviousAddress1"
                  [ngClass]="{'error': !previousResidenceInfoForm.get('PreviousAddress1').valid &&
                                        (previousResidenceInfoForm.get('PreviousAddress1').touched ||
                                          previousResidenceInfoForm.get('PreviousAddress1').dirty ||
                                          (formSubmitAttempt && !previousAddress1Cleared)) }" type="text"
            maxlength="40" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4" *ngIf="!previousResidenceInfoForm.get('PreviousAddress1').valid &&
                          (previousResidenceInfoForm.get('PreviousAddress1').touched ||
                            previousResidenceInfoForm.get('PreviousAddress1').dirty ||
                            (formSubmitAttempt && !previousAddress1Cleared))"
            (click)="clearValidations(previousResidenceInfoForm.get('PreviousAddress1'))" aria-label="Clear previous address1"
            (keyup)="$event?.keyCode ===  13 ? clearValidations(previousResidenceInfoForm.get('PreviousAddress1')) : null">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!previousResidenceInfoForm.get('PreviousAddress1').valid &&
                                (previousResidenceInfoForm.get('PreviousAddress1').touched ||
                                  previousResidenceInfoForm.get('PreviousAddress1').dirty ||
                                  (formSubmitAttempt && !previousAddress1Cleared))">
              <ng-container *ngIf="!!previousResidenceInfoForm.get('PreviousAddress1').errors?.required; else second">
                {{ prevResidenceInfoConfigData?.AddressLine1required }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!!previousResidenceInfoForm.get('PreviousAddress1').errors?.pattern">
                  {{prevResidenceInfoConfigData?.AddressLine1invalid}}
                </ng-container>
              </ng-template>
            </span>
          </div>
        </div>
        <!-- *************************** PreviousAddress1 END ***************************  -->

        <!-- *************************** PreviousAddress2 START ***************************  -->
        <div class="col-12 col-lg-6 col-xl-4 px-0">
          <label>{{ prevResidenceInfoConfigData?.AddressLine2label }}</label>
          <input class="form-control w-100 pr-5" id="previous_address2" formControlName="PreviousAddress2" [ngClass]="{'error': !previousResidenceInfoForm.get('PreviousAddress2').valid &&
                                                (previousResidenceInfoForm.get('PreviousAddress2').touched ||
                                                  previousResidenceInfoForm.get('PreviousAddress2').dirty ||
                                                  (formSubmitAttempt && !previousAddress2Cleared)) }" type="text"
            maxlength="40" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4" *ngIf="!previousResidenceInfoForm.get('PreviousAddress2').valid &&
                                (previousResidenceInfoForm.get('PreviousAddress2').touched ||
                                  previousResidenceInfoForm.get('PreviousAddress2').dirty ||
                                  (formSubmitAttempt && !previousAddress2Cleared))"
            (click)="clearValidations(previousResidenceInfoForm.get('PreviousAddress2'))" aria-label="Clear previous address2"
            (keyup)="$event?.keyCode ===  13 ? clearValidations(previousResidenceInfoForm.get('PreviousAddress2')) : null">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!previousResidenceInfoForm.get('PreviousAddress2').valid &&
                                  (previousResidenceInfoForm.get('PreviousAddress2').touched ||
                                    previousResidenceInfoForm.get('PreviousAddress2').dirty ||
                                    (formSubmitAttempt && !previousAddress2Cleared))">
              <ng-container *ngIf="!!previousResidenceInfoForm.get('PreviousAddress2').errors?.pattern">
                {{ prevResidenceInfoConfigData?.AddressLine2invalid }}
              </ng-container>
            </span>
          </div>
        </div>
        <!-- *************************** PreviousAddress2 END ***************************  -->

        <!-- *************************** PreviousZipcode START ***************************  -->
        <div class="d-none d-xl-block col-xl-4">
        </div>
        <div class="col-12 col-md-4 col-lg-4 col-xl-2 px-0 pr-md-3">
          <label>{{ prevResidenceInfoConfigData?.ZipCodeLabel }}</label>

          <input class="form-control w-100 pr-5" id="previous_zip_code" formControlName="PreviousZipcode" [ngClass]="{'error': !previousResidenceInfoForm.get('PreviousZipcode').valid &&
                                              (previousResidenceInfoForm.get('PreviousZipcode').touched ||
                                                previousResidenceInfoForm.get('PreviousZipcode').dirty ||
                                                (formSubmitAttempt && !previousZipCodeCleared)) }" type="text"
            [dtTextMask]="{ mask: previousZipCodeMask, guide:false }" />
          <a href="javascript:void(0);" class="locateMeButton mr-1" (click)="getBrowserZipcode()">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13" height="14" viewBox="0 0 13 14"><defs><style>.a{fill:none;}.b{clip-path:url(#a);}.c{fill:var(--pink-600);}</style><clipPath id="a"><path class="a" d="M0,0H13V14H0Z"/></clipPath></defs><path class="a" d="M0,0H13V14H0Z"/><g class="b"><path class="c" d="M9.072,14a.459.459,0,0,1-.462-.433L6.73,8.626a.462.462,0,0,0-.438-.3H6.268L.525,8.485a.475.475,0,0,1-.061,0,.467.467,0,0,1-.422-.265.444.444,0,0,1-.014-.345A.454.454,0,0,1,.27,7.622L12.261.077A.473.473,0,0,1,12.515,0V.027h.023a.467.467,0,0,1,.139.021.457.457,0,0,1,.273.227.443.443,0,0,1,.029.343L9.535,13.522a.446.446,0,0,1-.115.324A.463.463,0,0,1,9.1,14ZM6.254,7.231H6.3a1.584,1.584,0,0,1,1.472,1l1.2,3.157,2.55-9.571.005,0L2.732,7.331Z"/></g></svg>
          </a>
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4 ml-1 mr-1 mr-lg-0 zip-error-x" *ngIf="!previousResidenceInfoForm.get('PreviousZipcode').valid &&
                              (previousResidenceInfoForm.get('PreviousZipcode').touched ||
                                previousResidenceInfoForm.get('PreviousZipcode').dirty ||
                                (formSubmitAttempt && !previousZipCodeCleared))"
            (click)="clearValidations(previousResidenceInfoForm.get('PreviousZipcode'))" aria-label="Clear previous zipcode"
            (keyup)="$event?.keyCode ===  13 ? clearValidations(previousResidenceInfoForm.get('PreviousZipcode')) : null"
            tabindex="3">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!previousResidenceInfoForm.get('PreviousZipcode').valid &&
                                (previousResidenceInfoForm.get('PreviousZipcode').touched ||
                                  previousResidenceInfoForm.get('PreviousZipcode').dirty ||
                                  (formSubmitAttempt && !previousZipCodeCleared))">
              <ng-container *ngIf="!!previousResidenceInfoForm.get('PreviousZipcode').errors?.required; else second">
                {{ prevResidenceInfoConfigData?.ZipCodeRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!!previousResidenceInfoForm.get('PreviousZipcode').errors?.minlength; else third">
                  {{prevResidenceInfoConfigData?.ZipCodeInvalid}}
                </ng-container>
                <ng-template #third>
                  <ng-container *ngIf="!!previousResidenceInfoForm.get('Zipcode').errors?.invalidZipCode">
                    {{prevResidenceInfoConfigData?.ZipCodeInvalid}}
                  </ng-container>
                </ng-template>
              </ng-template>
            </span>
          </div>
        </div>
        <!-- *************************** PreviousZipcode END ***************************  -->

        <!-- *************************** PreviousCity START ***************************  -->
        <!-- <div class="d-none d-md-block d-lg-none col-md-6 order-md-4">
        </div> -->
        <div class="col-12 col-md-8 col-lg-5 col-xl-3 px-0 pr-lg-3">
          <label>{{ prevResidenceInfoConfigData?.CityLabel }}</label>
          <input class="form-control w-100 pr-5" id="previous_city" formControlName="PreviousCity" [ngClass]="{'error': !previousResidenceInfoForm.get('PreviousCity').valid &&
                                        (previousResidenceInfoForm.get('PreviousCity').touched ||
                                          previousResidenceInfoForm.get('PreviousCity').dirty ||
                                          (formSubmitAttempt && !previousCityCleared)) }" type="text" maxlength="30" />
          <span role="button" class="form-error-x dt-icon dt-icon-input-clear mt-4" *ngIf="!previousResidenceInfoForm.get('PreviousCity').valid &&
                          (previousResidenceInfoForm.get('PreviousCity').touched ||
                            previousResidenceInfoForm.get('PreviousCity').dirty ||
                            (formSubmitAttempt && !previousCityCleared))"
            (click)="clearValidations(previousResidenceInfoForm.get('PreviousCity'))" aria-label="Clear previous city"
            (keyup)="$event?.keyCode ===  13 ? clearValidations(previousResidenceInfoForm.get('PreviousCity')) : null"
            tabindex="3">

          </span>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!previousResidenceInfoForm.get('PreviousCity').valid &&
                                (previousResidenceInfoForm.get('PreviousCity').touched ||
                                  previousResidenceInfoForm.get('PreviousCity').dirty ||
                                  (formSubmitAttempt && !previousCityCleared))">
              <ng-container *ngIf="!!previousResidenceInfoForm.get('PreviousCity').errors?.required; else second">
                {{ prevResidenceInfoConfigData?.CityRequired }}
              </ng-container>
              <ng-template #second>
                <ng-container *ngIf="!!previousResidenceInfoForm.get('PreviousCity').errors?.pattern">
                  {{prevResidenceInfoConfigData?.CityInvalid}}
                </ng-container>
              </ng-template>
            </span>
          </div>
        </div>
        <!-- *************************** PreviousCity END ***************************  -->

        <!-- *************************** PreviousState START ***************************  -->
        <div class="col-12 {{isBuyNow || isLegacyCreditApp ? 'col-xl-1-half' : ''}} col-md-3 col-lg-2 px-0 pl-2-lg pl-md-0 pr-xl-3">
          <label>{{ prevResidenceInfoConfigData?.StateLabel }}</label>
          <select class="form-control w-100 gradient" id="previous_state" formControlName="PreviousState" [ngClass]="{'error': !previousResidenceInfoForm.get('PreviousState').valid &&
                                              (formSubmitAttempt ||
                                                (previousResidenceInfoForm.get('PreviousState').touched
                                                    || previousResidenceInfoForm.get('PreviousState').dirty))}">
            <option value="" [selected]="previousResidenceInfoForm.get('PreviousState').value === ''">
              {{ creditAppConfigData?.SelectsDefaultLabel }}
            </option>
            <option *ngFor="let state of states" [value]="state.Value"
              [selected]="state.Value === previousResidenceInfoForm.get('PreviousState').value">
              {{ state.Description }}
            </option>
          </select>
          <div class="form-validator_error">
            <span class="invalid-feedback d-block" *ngIf="!previousResidenceInfoForm.get('PreviousState').valid &&
                                (formSubmitAttempt ||
                                  (previousResidenceInfoForm.get('PreviousState').touched
                                      || previousResidenceInfoForm.get('PreviousState').dirty))">
              <ng-container *ngIf="!!previousResidenceInfoForm.get('PreviousState').errors?.required">
                {{ prevResidenceInfoConfigData?.StateRequired }}
              </ng-container>
            </span>
          </div>
        </div>
        <!-- *************************** PreviousState END ***************************  -->

        <!-- *************************** prevResidenceDurationGroup START ***************************  -->
        <div formGroupName="prevResidenceDurationGroup" class="col-12 col-lg-9 {{isBuyNow || isLegacyCreditApp ? 'col-xl-5' : 'col-xl-4'}} px-0" [ngClass]="{'group-padding': !this.isBuyNow && !isLegacyCreditApp}">
          <div class="row m-0 p-0">
            <!-- *************************** PreviousYearsAtAddress START ***************************  -->
            <div class="{{isLegacyCreditApp && isMobile()  ? 'col-12' : 'col'}} years-months p-0 pl-0 {{isLegacyCreditApp && isMobile() ? 'pr-0' : 'pr-2'}}">
              <label class="d-block">{{ prevResidenceInfoConfigData?.TotalYearsLabel }}</label>
              <select class="form-control gradient" id="previous_years_at_address" formControlName="PreviousYearsAtAddress"
                      [ngClass]="{'error':  previousResidenceInfoForm.get('prevResidenceDurationGroup').errors ||
                                            (!previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').valid &&
                                              (formSubmitAttempt ||
                                                (previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').touched
                                                    || previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').dirty)))}">
                <option value="" [selected]="previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').value === ''
                                            || previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let year of totalYearsAtAddress" [value]="year.Value"
                  [selected]="year.Value === previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').value">
                  {{ year?.Description }}
                </option>
              </select>
              <div class="form-validator_error">
                <span class="invalid-feedback d-block"
                      *ngIf="previousResidenceInfoForm.get('prevResidenceDurationGroup').errors ||
                              (!previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').valid &&
                                (formSubmitAttempt ||
                                  (previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').touched
                                      || previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').dirty)))">
                  <ng-container *ngIf="!!previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousYearsAtAddress').errors?.required; else second">
                    {{ prevResidenceInfoConfigData?.TotalYearsRequired }}
                  </ng-container>
                  <ng-template #second>
                      <ng-container *ngIf="!!previousResidenceInfoForm.get('prevResidenceDurationGroup').errors?.invalidselection">
                          {{ prevResidenceInfoConfigData?.TotalYrsZeroValidation }}
                        </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
            <!-- *************************** PreviousYearsAtAddress END ***************************  -->

            <!-- *************************** PreviousMonthsAtAddress START ***************************  -->
            <div class="{{isLegacyCreditApp && isMobile()  ? 'col-12' : 'col'}} years-months p-0 {{isLegacyCreditApp && isMobile() ? 'pl-0' : 'pl-2'}} pr-0">
              <label class="d-block">{{ prevResidenceInfoConfigData?.TotalMonthsLabel }}</label>
              <select class="form-control gradient" id="previous_months_at_address" formControlName="PreviousMonthsAtAddress"
                      [ngClass]="{'error':  previousResidenceInfoForm.get('prevResidenceDurationGroup').errors ||
                                            (!previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').valid &&
                                               (formSubmitAttempt ||
                                                 (previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').touched
                                                   || previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').dirty)))}">
                <option value="" [selected]="previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').value === ''
                                             || previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').value === null">
                  {{ creditAppConfigData?.SelectsDefaultLabel }}
                </option>
                <option *ngFor="let month of totalMonthsAtAddress" [value]="month.Value"
                  [selected]="month.Value === previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').value">
                  {{ month?.Description }}
                </option>
              </select>
              <div class="form-validator_error">
                <span class="invalid-feedback d-block"
                      *ngIf="previousResidenceInfoForm.get('prevResidenceDurationGroup').errors ||
                              (!previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').valid &&
                                (formSubmitAttempt ||
                                  (previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').touched
                                    || previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').dirty)))">
                  <ng-container *ngIf="!!previousResidenceInfoForm.get('prevResidenceDurationGroup.PreviousMonthsAtAddress').errors?.required; else second">
                    {{ prevResidenceInfoConfigData?.TotalMonthsRequired }}
                  </ng-container>
                  <ng-template #second>
                      <ng-container *ngIf="!!previousResidenceInfoForm.get('prevResidenceDurationGroup').errors?.invalidselection">
                          {{ prevResidenceInfoConfigData?.TotalMnthsZeroValidation }}
                        </ng-container>
                  </ng-template>
                </span>
              </div>
            </div>
            <!-- *************************** PreviousMonthsAtAddress END ***************************  -->
          </div>
        </div>
        <!-- *************************** prevResidenceDurationGroup START ***************************  -->
      </div>
    </div>
  </div>

</form>

<div class="credit-app-cta-section">
  <div class="row m-0 w-100 cta-section">
    <div class="col-12 p-0 d-flex cta-col cta-alignment m-0">
      <button
        id="back_cta"
        type="button"
        class="secondary-cta mr-auto"
        [disabled]="isSaving"
        (click)="goBack()"
      >
        {{  prevResidenceInfoConfigData?.BackCta  }}
      </button>
      <button
        id="next_cta"
        class="primary-cta ml-auto"
        [disabled]="!previousResidenceInfoForm.valid  || isSaving"
        (click)="goNext()"
      >
        {{prevResidenceInfoConfigData?.NextCta }}
      </button>
    </div>
  </div>
</div>
